const MINUTE_IN_MILLISECONDS = 60 * 1000;
const HOUR_IN_MILLISECONDS = 60 * MINUTE_IN_MILLISECONDS;
const URGENT_THRESHOLD_IN_MILLISECONDS = 3 * HOUR_IN_MILLISECONDS;

export const getMessageWindowCountdown = (expiresAt, now = Date.now()) => {
  if (!expiresAt) return null;

  const remainingMilliseconds = Number(expiresAt) * 1000 - now;
  if (remainingMilliseconds <= 0) {
    return { label: 'Janela encerrada', status: 'closed' };
  }

  const totalMinutes = Math.ceil(
    remainingMilliseconds / MINUTE_IN_MILLISECONDS
  );
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const label = `${hours}h ${String(minutes).padStart(2, '0')}min`;
  const status =
    remainingMilliseconds <= URGENT_THRESHOLD_IN_MILLISECONDS
      ? 'urgent'
      : 'open';

  return { label, status };
};
